import "./utils/productionConsoleGuard";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { startQueueSync } from "./utils/offlineQueue";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import AppUpdatePrompt from "./components/AppUpdatePrompt";
import { notifyServiceWorkerUpdateAvailable } from "./utils/appUpdateManager";
import GlobalLoadingBar from "./components/GlobalLoadingBar";

// 🚀 CACHE FRONTEND - Configuration React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,        // 5 minutes (synchronisé avec cache backend)
      cacheTime: 10 * 60 * 1000,       // 10 minutes (garde en mémoire)
      refetchOnWindowFocus: true,      // Revalider quand l'utilisateur revient
      refetchOnReconnect: true,        // Revalider après reconnexion
      retry: 1,                        // 1 seule retry en cas d'erreur
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalLoadingBar />
      <App />
      <PWAInstallPrompt />
      <AppUpdatePrompt />
      <ToastContainer autoClose={2000} /> {/* autoClose après 3s */}
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// 🚀 PWA : Enregistrer le Service Worker pour mode offline
// Compatible réseaux 3G instables (Afrique de l'Ouest)
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('✅ [PWA] Application prête pour mode offline');
    // Optionnel : Afficher une notification discrète
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification('ELSA GESTION', {
        body: 'Application disponible hors ligne',
        icon: '/elsa-logo-192.png',
        tag: 'pwa-ready',
      });
    }
  },
  onUpdate: (registration) => {
    console.log('🔄 [PWA] Mise à jour disponible');
    notifyServiceWorkerUpdateAvailable(registration);
  }
});

// Start background sync for offline actions
startQueueSync({
  immediate: true,
});
